import { Lang } from 'Roblox';
import avatarModule from '../avatarModule';

function advancedAccessoriesModalController($scope, $uibModalInstance, modalData) {
  'ngInject';

  $scope.params = modalData;

  $scope.submit = () => {
    $uibModalInstance.close();
  };

  $scope.close = () => {
    $uibModalInstance.dismiss();
  };
}

avatarModule.controller('advancedAccessoriesModalController', advancedAccessoriesModalController);

export default advancedAccessoriesModalController;
